import {useState} from 'react'
import {Navigate} from 'react-router-dom'
import {logout} from '../lib/allauth'
import Button from '../components/Button'
import {persistor} from "../../store";
import {resetUser} from "../../utils/posthog";

export default function Logout() {
    const [response, setResponse] = useState({fetching: false, content: null})

    async function submit() {
        setResponse({...response, fetching: true})
        try {
            resetUser();
            // Clear all persisted storage
            persistor.purge();
            
            // Then perform the backend logout
            logout().then((content) => {
                window.location.href = "/"; // hard redirect to home
            }).then(() => {
                setResponse((r) => ({...r, fetching: false}));
            }).catch((e) => {
                console.error(e);
                window.alert(e);
            }).then(() => {
                setResponse((r) => ({...r, fetching: false}));
            })
            
        } catch (e) {
            console.error(e);
            window.alert(e);
        } finally {
            setResponse((r) => ({...r, fetching: false}));
        }
    }

    if (response.content) {
        return <Navigate to='/'/>
    }
    return (
        <>
            <h1>Logout</h1>
            <p>
                Are you sure you want to logout?
            </p>

            <Button disabled={response.fetching} onClick={() => submit()}>Logout</Button>
        </>
    )
}
